module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/layout/app-layouts/empty-layout.component.html
// module id = ./src/app/shared/layout/app-layouts/empty-layout.component.html
// module chunks = main